import React from "react";
import Post from "../../components/Post";
import { BlogLayout } from "../../containers";
import { useParams } from "react-router-dom";

const Article = (props) => {
  const postDetails = props.location?.state?.id || {};
  return (
    <BlogLayout>
      <Post postDetails={postDetails} />
    </BlogLayout>
  );
};
export default Article;
